import LazyLoad from 'vanilla-lazyload';


function lazyload() {
	const lazyload = new LazyLoad();
	lazyload.update();
}

export default lazyload;